import { render, staticRenderFns } from "./MenuTable.vue?vue&type=template&id=0f9d3ee6&scoped=true"
import script from "./MenuTable.vue?vue&type=script&lang=js"
export * from "./MenuTable.vue?vue&type=script&lang=js"
import style0 from "./MenuTable.vue?vue&type=style&index=0&id=0f9d3ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d3ee6",
  null
  
)

export default component.exports